import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import {JazelAppConfig} from "@jazel/jazel-vuetify";

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const app = createApp(App)

app.use(vuetify)
app.use(pinia)
app.use(JazelAppConfig, {
  productId: 'lightning_model_page',
  isEmbedded:
    document.getElementById('lightning-model-page-admin')?.parentNode !== document.body,
  cdnUrl: import.meta.env.VITE_CDN_URL,
  jamsFrontendUrl: import.meta.env.VITE_JAMS_FRONTEND_URL,
  jamsBackendUrl: import.meta.env.VITE_JAMS_BACKEND_URL,
})
app.mount('#lightning-model-page-admin')
